import { ReactComponent as IconEndCall } from 'static/ic-end-call.svg';
import { AudioButton, ControlButton, VideoButton } from '../../../../../ui/components';
import type { WaitingApprovalControlsViewModel } from '../useWaitingApprovalViewModel';

type WaitingApprovalControlsProps = WaitingApprovalControlsViewModel & {
    onDismiss?: () => void;
};

export const WaitingApprovalControls = ({
    toggleAudio,
    selectAudioInputDevice,
    selectAudioOutputDevice,
    toggleVideo,
    selectVideoDevice,
    isPushToTalkEnabled,
    isMicToggleEnabled,
    onDismiss,
}: WaitingApprovalControlsProps) => (
    <>
        <AudioButton
            isPreJoinPage
            isPushToTalkEnabled={isPushToTalkEnabled}
            isToggleMicEnabled={isMicToggleEnabled}
            onClick={toggleAudio}
            onAudioInputSourceSelected={selectAudioInputDevice}
            onAudioOutputSourceSelected={selectAudioOutputDevice}
        />
        <VideoButton onClick={toggleVideo} onSourceSelected={selectVideoDevice} />
        <ControlButton variant="danger" shape="circle" IconImage={IconEndCall} onClick={onDismiss} />
    </>
);
